import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import NewBetSlip from 'Components/NewBetSlip';
import SystemSelect from 'Components/HorseRacing/SystemSelect';
import { TJK_URL_SUFFIX } from 'Store/constants/horseRacing';
import { useLocation } from 'react-router-dom';
import { classnames } from 'Utils/classnames';

const TjkLayout = ({ children, isNotFoundPage, page }) => {
  const [showNewBetslip, setShowNewBetslip] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setShowNewBetslip(location?.pathname?.includes(TJK_URL_SUFFIX.program.fullPage) || location?.pathname?.includes(TJK_URL_SUFFIX.fixedOdd.fullPage));
  }, [location]);


  if (isNotFoundPage) {
    return children;
  }

  return (
    <div className={ classnames({
      'tjk-layout': true,
      home: page === TJK_URL_SUFFIX.home.page,
    }) }>
      <div className='tjk-layout-content'>
        <div style={ { paddingLeft: showNewBetslip ? 0 : '' } } className='content-wrapper'>{ children }</div>
        { showNewBetslip && <NewBetSlip/> }
      </div>
      { location?.pathname?.includes(TJK_URL_SUFFIX.fixedOdd.fullPage) && <SystemSelect /> }
    </div>
  );
};

TjkLayout.propTypes = {
  children: PropTypes.node,
  isNotFoundPage: PropTypes.bool,
  page: PropTypes.string,
};

export default TjkLayout;
